module.exports = __webpack_public_path__ + "img/车明海.81014aeb.jpg";